import { nextTick, ref } from "vue";
import { useResizeObserver } from "@vueuse/core";
export default function useSliderDimensions({
  sliderRef,
  slideRefs,
  gap,
  checkMultiRows
}) {
  const totalWidth = ref(0);
  const containerWidth = ref(0);
  useResizeObserver(sliderRef, (entries) => {
    nextTick(() => {
      if (slideRefs.value && slideRefs.value.length > 0) {
        const firstRowTop = slideRefs.value[0]?.offsetTop || 0;
        totalWidth.value = slideRefs.value.reduce((sum, slide, index) => {
          const slideEl = slide.root?.$el || slide.root || slide;
          if (checkMultiRows && slideEl.offsetTop !== firstRowTop) {
            return sum;
          }
          const additionalGap = index < slideRefs.value.length - 1 ? gap : 0;
          return sum + slideEl.offsetWidth + additionalGap;
        }, 0);
        const entry = entries[0];
        const { width } = entry.contentRect;
        containerWidth.value = width;
      }
    });
  });
  return {
    totalWidth,
    containerWidth
  };
}
